const moneyFormats = new Map<string, Intl.NumberFormat>();

/** An amount in its currency (an ISO code): "₹1,23,456.50", "SAR 1,234.50".
    Rupees are grouped the Indian way. */
export const formatCurrency = (
  amount: number,
  currency: string,
  fractionDigits = 2,
): string => {
  const key = `${currency}:${fractionDigits}`;
  let format = moneyFormats.get(key);
  if (!format) {
    try {
      format = new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : 'en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      });
    } catch {
      // Not a currency code: still show the amount, never break the table.
      return `${currency} ${amount.toFixed(fractionDigits)}`;
    }
    moneyFormats.set(key, format);
  }
  return format.format(amount);
};
